import { createReactionStylesMap } from "@wantedly_private/ui-foundation";
import { useMemo } from "react";
export var useReactionCss = function useReactionCss(opts) {
  var map = useMemo(function () {
    return createReactionStylesMap({
      reactionType: opts.reactionType,
      baseElevation: opts.elevation,
      overlayType: opts.overlayType,
      background: opts.background,
      backwardCompatForUiReactLegacy: true
    });
  }, [opts.reactionType, opts.elevation, opts.overlayType, opts.background]);
  return map[opts.reaction];
};
//# sourceMappingURL=useReactionCss.js.map